import { AUTH_TOKEN_NAME } from "@/constants";
import { API_URLS, IN_APP_ROUTES } from "@/constants/urls";
import axios from "axios";
const BACKEND_API_URL = import.meta.env.VITE_BACKEND_URL


export const getToken = () => localStorage.getItem(AUTH_TOKEN_NAME);
export const setToken = (token) => localStorage.setItem(AUTH_TOKEN_NAME, token);
export const clearToken = () => localStorage.removeItem(AUTH_TOKEN_NAME);

export const apiClient = axios.create({
    baseURL: BACKEND_API_URL,
    withCredentials: true
})


let isRefreshing = false;
let failedRequestsQueue = [];

const processQueue = (error, token = null) => {
    failedRequestsQueue.forEach(({ config, resolve, reject }) => {
        if (error) {
            reject(error);
        } else {
            config.headers.Authorization = `Bearer ${token}`;
            resolve(apiClient(config));
        }
    });
    failedRequestsQueue = [];
};

export const fetchNewRefreshToken = async () => {
    try {
        const response = await apiClient.get(API_URLS.RENEW_REFRESH_TOKEN);
        return response.data.access_token;
    } catch (error) {
        clearToken()
    // signal : new AbortController().signal
        // window.location.replace(IN_APP_ROUTES.LOGIN_PAGE);
        throw error;
    }
};

apiClient.interceptors.request.use((config) => {
    const access_token = getToken();

    if (access_token) {
        config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
});

apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 &&
            !originalRequest.url.includes(API_URLS.RENEW_REFRESH_TOKEN) &&
            !originalRequest.url.includes(API_URLS.LOGIN) &&
            originalRequest &&
            !originalRequest._retry) {

            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedRequestsQueue.push({ config: originalRequest, resolve, reject });
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                const newToken = await fetchNewRefreshToken();
                setToken(newToken)

                apiClient.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;

                processQueue(null, newToken);

                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return apiClient(originalRequest);

            } catch (refreshError) {
                processQueue(refreshError, null);
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);

